<div id="logo-mobil">
    <h1>Mobil Assistance Oil Analysis</h1>
    <img src="/assets/images/logo-mobil.png" alt="Mobil Assistance Oil Analysis">
</div>
<div id="contenido">
    <p>Bienvenido al Laboratorio de Lubricantes <strong>Mobil Assistance</strong> de COPEC</p>    
</div>
<div id="logo-copec">
    <h3>COPEC</h3>
</div>